var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24PxThinkingSolving01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-thinking-solving-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,7.64a4.3,4.3,0,0,0-3.28-3.53c-.84-1.45-2.64-2.6-6.51-1.24C10.68,1.87,8.21,1.08,5.55,4A3.92,3.92,0,0,0,2.26,5.67,3.67,3.67,0,0,0,1.91,9a4.73,4.73,0,0,0,.29,4.15A4,4,0,0,0,5.28,15a5.23,5.23,0,0,0,4.34,3,6.14,6.14,0,0,0,3.89,1.11l2,2.93h4.82l-1.09-4.34c1.61-.61,2.13-1.32,2.74-3.29C23.1,11.93,23.42,10.19,22,7.64ZM20.1,13.57l-.06.14c-.4,1.33-.56,1.69-1.38,2l-.3-.41C17.51,14.08,16.09,12,11,12v2c4,0,5,1.36,5.71,2.45l.19.26L17.72,20H16.54l-2.08-3.11-.65.13a4.09,4.09,0,0,1-3.23-.83l-.2-.15-.25,0c-2.12-.29-2.8-1.22-3.08-2,.28-.81,1.25-3.22,3-4.07a3,3,0,0,1,2.6,0l.74-1.86a5,5,0,0,0-4.22.07c-2.15,1-3.35,3.53-3.84,4.8a2,2,0,0,1-1.41-.86,2.55,2.55,0,0,1-.25-1.92L6.07,10,5.93,8l-2.18.15a1.63,1.63,0,0,1,.17-1.37,2.13,2.13,0,0,1,2-.78l.51,0,.33-.39c1.65-2,2.92-1.92,4-1.32l-.61,1.23,1.78.9.83-1.65c2.63-.95,3.64-.46,4.07.08a5,5,0,0,0,.5,6.83l1.42-1.42a3,3,0,0,1-.33-4.18A2.39,2.39,0,0,1,20,8.19l0,.17.09.15C21.2,10.3,21.2,11.29,20.1,13.57Z",
    fill: "#242f47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24PxThinkingSolving01);
export default __webpack_public_path__ + "static/media/24px-thinking-solving-01.eef9cee0f47130a7ec17ceff1aaf79c1.svg";
export { ForwardRef as ReactComponent };